/**
 * 手帳・マイページ TOP で見ていた日（PRODUCT_DEV-1039 / 1043）
 *
 * 日を送ってから商談などを開き、戻ってくると毎回「今日」に戻っていて迷子になった。
 * 見ている日を画面の中の状態だけで持っていたため、画面を離れると消えた。
 *
 * - **戻ってきたときだけ**出す。← やブラウザの戻る・再読み込みは同じ履歴の枠へ戻るので、
 *   枠（`lib/nav/backTracker` の NavEntry）ごとに覚え、同じ枠のときだけ使う。
 *   タブバーやホームから開き直したときは新しい枠なので今日から（「今日を見たいのに別の日が出た」を避ける）
 * - **その日のうちだけ**。覚えた日（端末の今日）が変わっていたら使わない
 * - URL（`?date=`）には載せない。手帳のテナントでは `/` に何か付くと商談一覧へ送られる
 *   （`diaryTileMemory` と同じ理由）。sessionStorage（そのタブを開いているあいだだけ）に置く
 */
const KEY = "unizo.diary.lastDate";
/** 覚えておく枠の数。古いものから捨てる */
const LIMIT = 30;

interface Remembered {
  date: string;
  savedOn: string;
  at: number;
}

const readAll = (): Record<string, Remembered> => {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : null;
    return parsed && typeof parsed === "object" ? (parsed as Record<string, Remembered>) : {};
  } catch {
    return {};
  }
};

/** この枠で最後に見ていた日（`YYYY-MM-DD`）。無い・別の日に覚えたものなら null */
export function readRememberedDate(entryId: string | null, today: string): string | null {
  if (!entryId) return null;
  const r = readAll()[entryId];
  if (!r || typeof r.date !== "string" || r.savedOn !== today) return null;
  return r.date;
}

export function rememberDate(entryId: string | null, date: string, today: string): void {
  if (!entryId) return;
  try {
    const all = readAll();
    all[entryId] = { date, savedOn: today, at: Date.now() };
    const ids = Object.keys(all);
    if (ids.length > LIMIT) {
      ids
        .sort((a, b) => (all[a].at ?? 0) - (all[b].at ?? 0))
        .slice(0, ids.length - LIMIT)
        .forEach((id) => delete all[id]);
    }
    window.sessionStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    // 覚えられないだけ（戻ったときは今日から）
  }
}

/** ログアウトのとき消す（PRODUCT_DEV-1043。見ていた日は人ごとのものなので次の人に残さない） */
export function clearRememberedDates(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // 消せないだけ
  }
}
